
<template>
  <div>
    <WsBtn
      @click="$_onPopup()"
      color="primary"
      outlined
      block
      :disabled="_disabled"
    >
      <v-icon left>mdi-plus</v-icon> 新增相關法規
    </WsBtn>
    <WsChipList
      v-if="_articleChipList && _articleChipList.length > 0"
      class="mt-1"
      :chipList="_articleChipList"
      :textColor="closeChipTextColor"
      :borderColor="closeChipBorderColor"
      :backgroundColor="closeChipBackgroundColor"
      @chip-close="$_articleChipCloseClick($event)"
    ></WsChipList>
    <WsChipList
      v-if="_actChipList && _actChipList.length > 0"
      class="mt-1"
      :chipList="_actChipList"
      :textColor="closeChipTextColor"
      :borderColor="closeChipBorderColor"
      :backgroundColor="closeChipBackgroundColor"
      @chip-close="$_actChipCloseClick($event)"
    ></WsChipList>
    <WsActAddStepDialog
      ref="wsActAddStepDialog"
      :requiredField="requiredField"
      :requiredFieldState="requiredFieldState"
      :conditions="conditions"
      @create-submit="$_onCreateSubmit($event)"
    >
    </WsActAddStepDialog>
  </div>
</template>
<script>
export default {
  data: () => ({
    closeChipList: [],
    closeChipBackgroundColor: "#f7fafc",
    closeChipTextColor: "#353e4d",
    closeChipBorderColor: "#d7dee7",
    fetchedItems: {
      article_versions: [],
      act_version_alls: [],
    },
    isOriginValue: false,
    value: {
      article_versions: [],
      act_version_alls: [],
    },
  }),
  methods: {
    $_onPopup() {
      this.$refs.wsActAddStepDialog.open();
    },
    $_onCreateSubmit($event) {
      if ($event.article_versions.length) {
        if (this.fetchedItems.article_versions.length) {
          $event.article_versions.forEach(item => {
            const _index = this.fetchedItems.article_versions.findIndex(e => e.id === item.id);
            if (_index < 0) this.fetchedItems.article_versions.push(item);
          });
        } else {
          this.fetchedItems.article_versions = [
            ...this.fetchedItems.article_versions,
            ...$event.article_versions,
          ];
        }
      }
      if ($event.act_version_alls.length) {
        if (this.fetchedItems.act_version_alls.length) {
          const _index = this.fetchedItems.act_version_alls.findIndex(e => e.id === $event.act_version_alls[0].id);
          if (_index < 0) this.fetchedItems.act_version_alls.push($event.act_version_alls[0]);
        } else {
          this.fetchedItems.act_version_alls = [
            ...this.fetchedItems.act_version_alls,
            ...$event.act_version_alls
          ];
        }
      }
      this.$_getValue($event);
      this.$emit("input", this.value);
    },
    $_originValueToFetchedItems() {
      if (!this._originValue) return;
      this.fetchedItems = {
        article_versions: [],
        act_version_alls: [],
      };
      if (this._originValue.article_versions) {
        this.fetchedItems.article_versions = [
          ...this._originValue.article_versions,
        ];
      }
      if (this._originValue.act_version_alls) {
        this.fetchedItems.act_version_alls = [
          ...this._originValue.act_version_alls,
        ];
      }
      this.isOriginValue = true;
      this.$_getValue(this.originDataEX);
      this.$emit("input", this.value);
    },
    $_articleChipCloseClick($event) {
      const {act_version_id, article_id, article_version_id} = $event.value;
      const _index = this.value.article_versions.findIndex(item =>
        item.act_version_id === act_version_id &&
        item.article_id === article_id &&
        item.article_version_id === article_version_id
      );
      this.value.article_versions.splice(_index, 1);
    },
    $_actChipCloseClick($event) {
      const _index = this.value.act_version_alls.findIndex(item => item.act_version_id === $event.value);
      this.value.act_version_alls.splice(_index, 1);
    },
    $_getValue(modelData) {
      if (modelData.article_versions.length) {
        const _article_versions = modelData.article_versions.map(mapItem => {
          const {id: article_version_id, article, act_versions} = mapItem;
          return {
            article_id: article.id,
            article_version_id,
            act_version_id: act_versions[mapItem.act_versions.length -1].id,
          };
        });
        this.value.article_versions = [
          ...this.value.article_versions,
          ..._article_versions,
        ];
        this.value.article_versions = this.value.article_versions.filter(
          (filterItem, filterIndex, filterArr) =>
          filterArr.indexOf(filterItem) === filterIndex
        );
      }
      if (modelData.act_version_alls.length) {
        const _act_version_alls = modelData.act_version_alls.map(mapItem => {
          const {id: act_version_id, act} = mapItem;
          return {
            act_id: act.id,
            act_version_id,
          };
        });
        this.value.act_version_alls = [
          ...this.value.act_version_alls,
          ..._act_version_alls,
        ];
        this.value.act_version_alls = this.value.act_version_alls.filter(
          (filterItem, filterIndex, filterArr) =>
          filterArr.indexOf(filterItem) === filterIndex
        );
      }
    },
  },
  computed: {
    _disabled() {
      if (this.requiredField && !this.requiredFieldState) {
        return true;
      } else {
        return false;
      }
    },
    _articleChipList() {
      if (!this.hasCloseChips || !this.fetchedItems) return null;
      let newArr = [];
      if (this.value.article_versions.length) {
        this.value.article_versions.forEach((articleItem) => {
          let _articleIndex = this.fetchedItems.article_versions.findIndex(
            (e) => {
              return e.id === articleItem.article_version_id;
            }
          );
          let text = "";
          if (this.fetchedItems.article_versions[_articleIndex].act_versions) {
            text = `${
              this.fetchedItems.article_versions[_articleIndex].act_versions[0]
                .name
            }-${
              this.fetchedItems.article_versions[_articleIndex].no_text
            } (${this.$moment(
              this.fetchedItems.article_versions[_articleIndex].announce_at
            ).format("YYYY-MM-DD")})`;
          } else {
            text = `${this.fetchedItems.article_versions[_articleIndex].no_text}`;
          }
          newArr.push({
            value: articleItem,
            text: text,
          });
        });
        return newArr;
      } else {
        return null;
      }
    },
    _actChipList() {
      if (!this.hasCloseChips || !this.fetchedItems) return null;
      if (this.fetchedItems.act_version_alls) {
        let newArr = [];
        this.value.act_version_alls.forEach(item => {
          const _index = this.fetchedItems.act_version_alls.findIndex(act => act.id === item.act_version_id);
          if (_index >= 0) {
            const text = `${
              this.fetchedItems.act_version_alls[_index].name
            } (${this.$moment(item.announce_at).format("YYYY-MM-DD")})`;
            newArr.push({
              value: item.act_version_id,
              text,
            });
          }
        });
        return newArr;
      } else {
        return null;
      }
    },
    _originValue() {
      if (!this.originDataEX) return;
      let newObj = {};
      if (
        !this.originDataEX.article_versions ||
        !this.originDataEX.act_version_alls
      )
        return;
      if (this.originDataEX.article_versions.length) {
        newObj.article_versions = this.originDataEX.article_versions;
      }
      if (this.originDataEX.act_version_alls.length) {
        newObj.act_version_alls = this.originDataEX.act_version_alls;
      }
      return newObj;
    },
  },
  props: {
    requiredField: {
      type: String,
      default: "",
    },
    requiredFieldState: {
      default: null,
    },
    hasCloseChips: {
      type: Boolean,
      default: false,
    },
    originDataEX: {
      type: Object,
    },
    conditions: {
      type: Array,
    },
  },
  mounted() {
    this.$_originValueToFetchedItems();
  },
  watch: {
    _originValue: {
      handler() {
        this.$_originValueToFetchedItems();
      },
      deep: true,
    },
  },
};
</script>